import { DataTableDataItem, IDataTable } from '@shared/models/data-table.model';
import { IElementProperty } from '@shared/models/element-property.model';
import { getCount } from '../element-property.helpers';
import { formatExpressionVariableName } from '../expression-variables.helpers';
import { isDataTableMainProperty } from './data-table.helpers';

/**
 * Get a specific item in the data table data array based on the selected value (count)
 * @param property
 * @param dataTables
 * @returns
 */
export const getSelectedDataTableItemFromProperty = (
  property: IElementProperty,
  dataTables: IDataTable[] = [],
): { name: string; item: DataTableDataItem } | undefined => {
  if (isDataTableMainProperty(property)) {
    const dataTable = dataTables.find(
      (dataTable) => dataTable.id === property.table_id,
    );

    // Just don't update any
    if (!dataTable) {
      return undefined;
    }
    const count = getCount(property);

    // Find the item in data-array user have selected
    const item = dataTable.data.find(
      (item) => item[dataTable.index_key] === count,
    );
    if (!item) {
      console.error(
        `JSON item not found for data table ${property.table_id} with value ${count}`,
      );
    }
    return {
      name: formatExpressionVariableName(dataTable.name),
      item: item ?? {},
    };
  }
};
